import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { HeaderModule } from '@progress/kendo-angular-grid';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CommonService } from '../service/common/common.service';
import { items } from './menuitems';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  public itemLists: any[] = items;
  public items: any[] = [];
  public userName: string = '';
  public roles: string = '';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService, private msalBroadcastService: MsalBroadcastService,
    private router: Router, private commonService: CommonService) {
    this.userName = localStorage.getItem('username');
    this.roles = localStorage.getItem('roles');
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    /**
     * You can subscribe to MSAL events as shown below. For more info,
     * visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/events.md
     */
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.getUserName(this.authService.instance.getActiveAccount()?.idTokenClaims);
        this.getAdminCheck();
      });
  }

  checkUrlPath(path: any) {
    // If the user in Sub agreement entry page and clicks the same page from the menu, it will route to the same page.
    this.router.navigate([path]);
    // $(document).ready(function(){
    // $('.activeMenu').removeClass("activeMenu");
    // $('.active').parent().addClass("activeMenu");
    // });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.getUserName(this.authService.instance.getActiveAccount()?.idTokenClaims);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.getUserName(this.authService.instance.getActiveAccount()?.idTokenClaims);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    this.authService.logout();
  }

  getUserName(claims: any) {
    if (claims) {
      this.userName = claims['name'];
      localStorage.setItem('username', this.userName);
      if (claims.roles) {
        this.roles = claims['roles'];
        localStorage.setItem('roles', this.roles);
      }
    }
    else if (localStorage.getItem('username')) {
      this.userName = localStorage.getItem('username');
      if (localStorage.getItem('roles')) {
        this.roles = localStorage.getItem('roles');
      }
    }
  }

  getAdminCheck() {
    this.commonService.getAdminCheck().subscribe((res) => {
      if (res === false) {
        this.items = [];
        this.itemLists.forEach((ele: any) => {
          if (ele.id !== '2') {
            this.items.push(ele);
          }
        });
      } else {
        this.items = this.itemLists;
      }
    });
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
